import { MrbBaseRouteStore } from "mrb/core";
import { CouponService, PaymentService, ProductService } from "common/services";
import { split } from "lodash";
import moment from "moment";

class RegisterRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.couponService = rootStore.createApplicationService(CouponService);
        this.paymentService = rootStore.createApplicationService(PaymentService);
        this.productService = rootStore.createApplicationService(ProductService);
    }

    register = (data) => {
        return this.rootStore.application.baasic.membershipModule.register.create(
            {
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                password: data.password,
                confirmPassword: data.confirmPassword,
                userName: generateUserName(data.email),
                activationUrl: generateActivationUrl(),
                challengeResponse: data.recaptcha,
            }
        );
    };

    async getSubscriptionPlans() {
        const response = await this.productService.getAllSubscriptions();
        return response.data;
    }

    validateSignupPromoCode(promoCode) {
        return this.couponService.validateSignupPromoCode(promoCode).then((response) => response.data);
    }

    login = async (email, password) => {
        await this.rootStore.authenticationStore.login(email, password, ["sliding"]);
        await this.rootStore.userStore.resolveUser();
        const redirect = this.rootStore.authenticationStore.getSignInRedirect();
        await this.rootStore.routerStore.goTo(redirect);
    };

    registerAccount(data) {
        return this.paymentService.signupRegister({
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            password: data.password,
            confirmPassword: data.confirmPassword,
            challengeResponse: data.recaptcha,
        }).then((r) => r.data.access_token);
    }

    async finalizeLogin(token) {
        this.rootStore.application.baasic.tokenHandler.store({ access_token: token, token_type: "bearer" });
        await this.rootStore.userStore.resolveUser();
        const redirect = this.rootStore.authenticationStore.getSignInRedirect();
        await this.rootStore.routerStore.goTo(redirect);
    }

    subscribePreprocess(planId, promoCode, authToken, providerPaymentMethodId = null) {
        return this.paymentService
            .preprocess(planId, promoCode, null, authToken, providerPaymentMethodId)
            .then((r) => r.data);
    }

    // Creates a SetupIntent so the browser can confirm a card. On the sign-up card-first path this runs BEFORE
    // preprocess and the resulting payment method is passed into it, so the subscription is created already
    // carrying a usable card. On the original path it runs after preprocess, when the first invoice came back
    // at $0 and no charge is needed. Token-scoped so it runs before sign-in.
    subscribeSetupPaymentMethod(authToken) {
        return this.paymentService.setupPaymentMethodRequest(null, authToken).then((r) => r.data);
    }

    subscribePostprocess(data, authToken) {
        return this.paymentService.postprocess(data, null, authToken).then((r) => r.data);
    }

    deleteAccount(authToken) {
        return this.paymentService.deleteSignupAccount(authToken);
    }
}

export function generateUserName(email) {
    const name = split(email, "@")[0].replace("+", "");
    return `${name}_${moment().unix()}`;
}

function generateActivationUrl() {
    return `${window.location.origin}/account-activation?activationToken={activationToken}`;
}

export default RegisterRouteStore;
